import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  showPassword: {
    id: 'react-components.JHTwdB',
    defaultMessage: 'Show password',
  },
  hidePassword: {
    id: 'react-components.K3fWTv',
    defaultMessage: 'Hide password',
  },
});
